export function planFeaturesListResponse(json, headers) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
    })),
    total: headers.get("X-Total-Count") ? parseInt(headers.get("X-Total-Count").split("/").pop(), 10) : 1000,
  };
}

export function fixUpdatePlanFeaturesId(json) {
  return {
    data: {...json.result, id: json.result.objectId},
  };
}

export function fixCreatePlanFeaturesId(params, json) {
  return {
    data: {...params.data, id: json.result.objectId},
  };
}

export function planFeaturesMapperGetOneResponse(json) {
  return {
    data: {...json.result, id: json.result.objectId,
    },
  };
}